var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
var Stage = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M20 8C20 10.2091 18.2091 12 16 12C15.8996 12 15.8 11.9963 15.7015 11.989L6.97859 19.6857L6 18.7071L3.85355 20.8536C3.65829 21.0488 3.34171 21.0488 3.14645 20.8536C2.95118 20.6583 2.95118 20.3417 3.14645 20.1464L5.29289 18L4.3143 17.0214L12.011 8.29851C12.0037 8.19996 12 8.10041 12 8C12 5.79086 13.7909 4 16 4C18.2091 4 20 5.79086 20 8ZM19 8C19 8.64791 18.7946 9.24784 18.4454 9.73825L14.2618 5.55461C14.7522 5.20539 15.3521 5 16 5C17.6569 5 19 6.34315 19 8ZM16 11C16.6479 11 17.2479 10.7946 17.7383 10.4454L13.5546 6.26171C13.2054 6.75213 13 7.35208 13 8C13 9.65685 14.3431 11 16 11ZM7.02141 18.3143L14.5049 11.7112C13.4983 11.3053 12.6947 10.5017 12.2888 9.4951L5.6857 16.9786L7.02141 18.3143Z", fillRule: "evenodd", clipRule: "evenodd" })));
};
Stage.displayName = 'Stage';
export default Stage;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Stage.js.map